import EachLink from "./EachLink";
import { motion } from "framer-motion";
// types
import { LinkType } from "types/allTypes";
import MobileMenu from "./MobileMenu";
import { LogoSVG } from "assets/svg";
import { useRouter } from "next/router";
import { logoFont } from "assets/font";
import { useEffect, useState } from "react";

const Header: React.FC = () => {
  const router = useRouter();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const headerLinks: LinkType[] = [
    {
      ref: "/",
      text: "Home",
    },
    {
      ref: "/#projects",
      text: "Our work",
    },
    {
      ref: "/#team",
      text: "Team",
    },
    {
      ref: "/#contact-us",
      text: "Contact us",
    },
  ];
  const clickHandler = () => {
    router.push("/", undefined, { scroll: false, shallow: true });
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div
      className={`fixed top-0 left-0 w-full h-28 z-[10000] pointer-events-none duration-300 border-b ${
        scrolled
          ? "bg-[#07070B]/70 backdrop-blur-xl border-white/10"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="flex justify-start items-center w-full h-full relative">
        <span
          className="absolute top-10 left-[32px] lg:left-32 z-100 pointer-events-auto cursor-pointer"
          onClick={clickHandler}
        >
          <div className="flex justify-start items-center hover:scale-105 duration-500">
            <LogoSVG width="3.25rem" />
            <span
              className={`text-[26px] text-white font-bold ${logoFont.className}`}
            >
              Spila
            </span>
          </div>
        </span>
        <motion.ul className="absolute pointer-events-auto top-1/2 -translate-y-1/2 right-[32px] lg:right-32 hidden lg:flex justify-start items-center gap-x-5 lg:gap-x-8 z-110">
          {headerLinks.map((headLink) => {
            return <EachLink key={headLink.ref} headLink={headLink} />;
          })}
          <li>
            <a
              href="/#contact-us"
              className="inline-flex items-center rounded-full bg-white text-[#0B0B10] text-sm font-semibold px-5 py-2.5 hover:bg-primary-70 duration-300 active:scale-95 no-select-a-tag"
            >
              Start a project
            </a>
          </li>
        </motion.ul>
        <MobileMenu headerLinks={headerLinks} />
      </div>
    </div>
  );
};

export default Header;
